module.exports = __webpack_public_path__ + "img/6.79584539.jpg";